module.exports = __webpack_public_path__ + "static/media/books.9487faab.md";